var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 28,
    viewBox: "0 0 16 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37273 8.71559C6.37273 7.55411 7.19378 7.10668 8.51016 7.10668C10.4271 7.10668 12.8599 7.79907 14.7769 9.01804V2.02497C12.6882 1.04096 10.6038 0.666016 8.5144 0.666016C3.40505 0.666016 0 3.81136 0 9.07054C0 17.2934 9.57428 15.9603 9.57428 19.5064C9.57428 20.8812 8.56315 21.3236 7.15845 21.3236C5.07402 21.3236 2.37979 20.3079 0.264971 18.954V25.6454C2.44073 26.7524 4.78458 27.3265 7.15421 27.3327C12.3922 27.3327 16 24.6764 16 19.3339C16 10.4711 6.37273 12.0592 6.37273 8.71559Z",
    fill: "#5E56F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.baae210555e7ff31bb9827d99fe2d5d0.svg";
export { ForwardRef as ReactComponent };